import { getErrorHandler } from '@office-start/error-handler';
import { addOnVisibilityChangeListener, getIsPageVisible, } from '@office-start/page-visibility-service';
import { mark as markPerformance } from '@office-start/performance-service';
import { createHandle, createNoopHandle } from './Handles';
import { heap } from './Heap';
import { cancelIdleCallbackPolyfill, requestIdleCallbackPolyfill, } from './IdleCallbackPolyfills';
import { IMMEDIATE_PRIORITY, } from './Models';
// Handle to a queued idle callback, returned from "requestIdleCallback" API.
var idleCallbackHandle;
// A flag that determine if the page is visible or not. When the page is hidden,
// we try to drain the idle task queue ASAP since these tasks won't affect
// user perceived performance.
var isPageHidden = false;
var shouldLogFirstIdle = getIsPageVisible(); // We cannot accurately log "First Idle" if tab is hidden at any point.
var shouldLogFirstSchedule = true;
function doWork(deadline) {
    while (isPageHidden || (deadline && deadline.timeRemaining() > 0)) {
        var scheduledWork = heap.pop();
        if (!scheduledWork) {
            break;
        }
        if (scheduledWork.cancelled) {
            continue;
        }
        try {
            scheduledWork.work(deadline);
            scheduledWork.completed = true;
        }
        catch (ex) {
            var errorHandler = getErrorHandler();
            errorHandler.handleError(ex, "DXUlK" /* DXUlK */);
        }
    }
    // If we run out of time, but there are more tasks to do, schedule them for later.
    if (heap.peek()) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        dequeueWhenIdle();
    }
}
addOnVisibilityChangeListener(function (visibilityState) {
    isPageHidden = visibilityState !== 'visible';
    if (isPageHidden) {
        shouldLogFirstIdle = false;
        if (idleCallbackHandle) {
            // When the user hides the page, cancel any queued idle tasks, and run them now.
            cancelIdleCallbackPolyfill(idleCallbackHandle);
            idleCallbackHandle = null;
        }
        doWork();
    }
});
function dequeueWhenIdle() {
    // When the page is hidden, we can immediately begin processing tasks.
    if (isPageHidden) {
        doWork();
    }
    // If there is already an IdleCallback handle, we have already scheduled
    // work to happen when idle.
    if (idleCallbackHandle) {
        return;
    }
    // Schedule work to run when idle.
    idleCallbackHandle = requestIdleCallbackPolyfill(function (deadline) {
        if (shouldLogFirstIdle) {
            shouldLogFirstIdle = false;
            markPerformance('First_Idle_React');
        }
        idleCallbackHandle = null;
        doWork(deadline);
    });
}
export function scheduleWork(work, priority) {
    if (priority === IMMEDIATE_PRIORITY) {
        work();
        return createNoopHandle();
    }
    if (shouldLogFirstSchedule) {
        shouldLogFirstSchedule = false;
        markPerformance('First_Schedule_React');
    }
    var scheduledWork = {
        work: work,
        priority: priority,
        cancelled: false,
        completed: false,
    };
    var workHandle = createHandle(scheduledWork);
    heap.push(scheduledWork);
    dequeueWhenIdle();
    return workHandle;
}
//# sourceMappingURL=Scheduler.js.map